export enum TrendValueEnum {
  VeryPositive = 'very positive',
  Neutral = 'neutral',
  Positive = 'positive',
  Negative = 'negative',
  VeryNegative = 'very negative',
  Insufficient = 'insufficient',
}

export type TrendValue =
  | TrendValueEnum.VeryPositive
  | TrendValueEnum.Neutral
  | TrendValueEnum.Positive
  | TrendValueEnum.Negative
  | TrendValueEnum.VeryNegative
  | TrendValueEnum.Insufficient;
